import React from "react";
import { cn } from "@/lib/utils";
import LoadingSpinner from "./LoadingSpinner";

interface PageLoadingProps {
  message?: string;
  className?: string;
  fullScreen?: boolean;
}

const PageLoading: React.FC<PageLoadingProps> = React.memo(
  ({ message, className, fullScreen = true }) => {
    return (
      <div
        className={cn(
          "flex flex-col items-center justify-center bg-Color-Background-neutral-default_primary",
          fullScreen ? "min-h-screen w-full" : "min-h-[400px] w-full",
          className,
        )}
      >
        <LoadingSpinner size="lg" message={message} showBackground={false} />
      </div>
    );
  },
);

PageLoading.displayName = "PageLoading";

// Specialized loading components for different contexts
export const RouteLoading: React.FC<{ message?: string }> = React.memo(
  ({ message = "Đang tải..." }) => (
    <PageLoading message={message} fullScreen={true} />
  ),
);

export const ComponentLoading: React.FC<{
  className?: string;
  message?: string;
}> = React.memo(({ className, message }) => (
  <div className={cn("flex items-center justify-center p-8", className)}>
    <LoadingSpinner size="md" message={message} />
  </div>
));

export const InlineLoading: React.FC<{
  size?: "sm" | "md";
  message?: string;
  className?: string;
}> = React.memo(({ size = "sm", message, className }) => (
  <div className={cn("flex items-center gap-2", className)}>
    <LoadingSpinner size={size} />
    {message && (
      <span className="text-sm text-Color-Text-neutral-secondary">
        {message}
      </span>
    )}
  </div>
));

// Loading states for specific screens - all use consistent yellow spinner design
export const HomeScreenLoading: React.FC = React.memo(() => (
  <PageLoading message="Đang tải trang chủ..." />
));

export const ProfileScreenLoading: React.FC = React.memo(() => (
  <PageLoading message="Đang tải thông tin..." />
));

export const FormScreenLoading: React.FC = React.memo(() => (
  <PageLoading message="Đang tải biểu mẫu..." />
));

export const ListScreenLoading: React.FC = React.memo(() => (
  <PageLoading message="Đang tải danh sách..." />
));

export default PageLoading;
